export { default as commonDefinitions } from 'vets-json-schema/dist/definitions.json';

export {
  VaRadio,
  VaRadioOption,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
